// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Link":"Link-2ffrv1e5tjucwszcuzj1bu469sajf3br83ywr9wu8rx4ug9cm1ratqv485shdbvy3rhv8c1jtk3xq9fy1c468ru8jw43qtfxpyw9g6k","loading":"loading-3825zkvcd55xp9v9a9uyt1vk9ujmtv23am9sp7mmtf5hfrvsjgyzh9kbgv25459qybk7w4fezw4cu77mbbafuz5jgyzmy4gkszcnkc","pulse":"pulse-3hnyz88swyhbbv2w2t4ar6vcv89xwf5w4jhdu6k5cxm8m2s851fvkc223jvpxbvqvyd89v7p9m2bc98wrx4515zhs24dj9qhvjywddk"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Link/Link.module.scss
// module id = 1789
// module chunks = 0